import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "11",
  height: "14",
  viewBox: "0 0 11 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]


const __default__ = {};

interface Props{
        fill?:string;
    }

    
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'IconCard',
  props: {
    fill: { default: '#FFE100' }
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M0 3C0 1.34315 1.34315 0 3 0H8C9.65685 0 11 1.34315 11 3V11C11 12.6569 9.65685 14 8 14H3C1.34315 14 0 12.6569 0 11V3Z",
      fill: _ctx.fill
    }, null, 8, _hoisted_2)
  ]))
}
}

})